<template>
	<div v-bind:centered="centered" :class="$style.container">
		<ProjectGaugeChart :chartData="chartData" :options="options" :width="64" :height="64" label="PERCENT" segmentStrokeStyle="#EEE"  />
	</div>

</template>

<style lang="scss" module rel="stylesheet/scss">
	.container {
		width: 64px;
		box-sizing: border-box;
		height: 64px;

		&[centered='true'] {
			margin-left: 32px;
		}
		&:after {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			box-sizing: border-box;
			border: 1px solid rgba(#fff, .6);
		}
	}
</style>

<script>
	import ProjectGaugeChart from '../../../components/charts/ProjectGauge';

	export default {
		components: {
			ProjectGaugeChart
		},
		props: {
			data: Object,
			centered: Boolean,
			fillBackground: {
				String,
				default: '#00a155'
			},
			centerLabelColor: {
				String,
				default: '#757575'
			},
			emptyBackground: {
				String,
				default: '#CDCDCD'
			}
		},
		data() {
			return {
				is_shown_chart: false,
				chartData: {
					datasets: [{
						data: [0, 100],
						backgroundColor: [this.fillBackground, this.emptyBackground],
						hoverBackgroundColor: [this.fillBackground, this.emptyBackground],
						centerLabelColor: this.centerLabelColor,
						borderWidth: 0,
						centerLabelSize: 40
					}]
				},
				options: {
					cutoutPercentage: 82,
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					}
				}
			}
		},
		watch: {
			data: {
				handler() {
					this.fillData();
				},
				immediate: true
			}
		},
		methods: {
			fillData () {
				const {value} = this.data;
				const maxValue = 100;

				const {
					fillBackground,
					centerLabelColor,
					emptyBackground
				} = this;

				this.chartData = {
					datasets: [{
						data: [value, maxValue - value],
						backgroundColor: [fillBackground, emptyBackground],
						hoverBackgroundColor: [fillBackground, emptyBackground],
						centerLabelColor: centerLabelColor,
						borderWidth: 0,
						centerLabelSize: 40
					}]
				}
				this.is_shown_chart = true;
			}
		}
	}
</script>
